import { combineReducers } from 'redux'
import post from './post'
import user from './user'
import history from './history'
import sign from './sign'

const rootReducer = combineReducers({ post, user, history, sign })

export default rootReducer
